// extracted by mini-css-extract-plugin
export var container = "CategoryCard-module--container--221c9";
export var description = "CategoryCard-module--description--ed021";
export var titleLink = "CategoryCard-module--titleLink--41264";